import { render, staticRenderFns } from "./SalesItemNew.vue?vue&type=template&id=036bbcb1&"
import script from "./SalesItemNew.vue?vue&type=script&lang=js&"
export * from "./SalesItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports